<template>
    <div class="main">
        <div v-if="Phone">
            <el-form ref="form" :model="form" size="mini" :rules="rules" label-width="auto">
                <h5>基础信息</h5>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="省份" prop="HospitalProvince">
                            <el-input v-model="form.HospitalProvince" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="姓名" prop="Name">
                            <el-input v-model="form.Name" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="医院" prop="HospitalName">
                            <el-select v-model="form.HospitalName" placeholder="请输入医院" style="width:100%" filterable remote
                                :remote-method="hosRemoteMethod" :loading="loading" clearable @change="handleHosChange"
                                @clear="handleClear">
                                <el-option v-for="(item, index) in hospitalOptions" :key="index" :label="item.label"
                                    :value="item.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="科室" prop="Department">
                            <el-select v-model="form.Department" placeholder="请选择科室" filterable clearable style="width:100%">
                                <el-option v-for="(item, index) in departmentList" :key="index" :value="item.Value"
                                    :label="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="职务" prop="JobTitle">
                            <el-select v-model="form.JobTitle" placeholder="请选择职务" filterable style="width:100%">
                                <el-option v-for="(item, index) in JobOptions" :key="index" :label="item.Name"
                                    :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="手机号" prop="Phone">
                            <el-input v-model="form.Phone" placeholder="请输入手机号" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备用手机号1" prop="Phone1">
                            <el-input v-model="form.Phone1" placeholder="请输入手机号" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="医院地址">
                            <el-input v-model="form.HospitalAddress" placeholder="自动获取医院地址" readonly></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="身份证号" prop="IDCardNumber">
                            <el-input v-model="form.IDCardNumber" placeholder="请输入证件号" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="性别" prop="Sex">
                            <el-radio-group v-model="form.Sex">
                                <el-radio v-for="(item, index) in SexOptions" :key="index" :label="item"
                                    :value="item"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <h5>扩展信息</h5>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Vip联系人" prop="">
                            <el-select v-model="form.VipContacts" placeholder="请选择Vip联系人序号" filterable clearable
                                style="width:100%">
                                <el-option v-for="(item, key) in VIPoptions" :key="key" :value="item" :label="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="设备Vip联系人" prop="">
                            <el-select v-model="form.VipContactsDev" placeholder="请输入设备Vip联系人" filterable clearable style="width:100%">
                                <el-option
                                    v-for="item in ['肾科设备1','肾科设备2','肾科设备3','肝科设备1','肝科设备2','肝科设备3','重症设备1','重症设备2','重症设备3']"
                                    :key="item" :value="item" :label="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24">
                        <el-form-item label="月历类型">
                            <el-radio-group v-model="form.MonthlyCalendar" @change="handleCalendarTypeChange">
                                <el-radio v-for="(item, index) in MonthlyCalendarOptions" :key="index" :label="item.Name"
                                    :value="item.Value"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="出生日期" prop="Birthday">
                            <el-date-picker v-model="form.Birthday" type="date" placeholder="请选择出生日期" value-format="yyyy-MM-dd"
                                @change="handleDateChange" style="width:100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="新历生日" prop="XLBirthday">
                            <el-input v-model="XLBirthday" placeholder="填写出生日期自动转换" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="是否在岗">
                            <el-radio-group v-model="form.JobState">
                                <el-radio v-for="(item, index) in ['是', '否']" :key="index" :label="item"
                                    :value="item"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="家庭住址">
                            <el-input v-model="form.Address" placeholder="请输入家庭住址" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="添加微信时间">
                            <el-input v-model="form.WeChat" placeholder="添加微信时间" clearable
                                @focus="changeTime('WeChat')"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="客服确认时间" prop="ConfirmTime">
                            <el-input v-model="form.ConfirmTime" placeholder="添加确认时间" clearable
                                @focus="changeTime('ConfirmTime')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input v-model="form.Remark" placeholder="请输入备注信息" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row>
                <el-col :span="24" class="foot">
                    <el-button type="primary" size="medium" icon="el-icon-folder-checked" @click="save" :loading="btnLoading"
                        :disabled="btnLoading">保 存</el-button>
                    <el-button type="info" size="medium" icon="el-icon-refresh" @click="init" :loading="btnLoading"
                        :disabled="btnLoading">刷 新</el-button>
                    <!-- <el-button type="success" size="medium" icon="el-icon-coin" @click="SynchronousData(form.Profile)" :loading="btnLoading" :disabled="btnLoading">同 步</el-button> -->
                </el-col>
            </el-row>
        </div>
        <div v-else>
            <div style="text-align: center;width: 100%;font-size: 18px;">无关联数据</div>
            <el-row>
                <el-col :span="24" class="foot">
                    <el-button type="primary" size="medium" icon="el-icon-folder-checked" @click="init" :loading="btnLoading"
                        :disabled="btnLoading">刷 新</el-button>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<!-- 引入组件库 -->
<script src="https://unpkg.com/element-ui/lib/index.js"></script>

<script>
    import * as ww from '@wecom/jssdk'
    import calendar from '@/util/calendar'
    import axios from 'axios';
    import Vue from 'vue';
    import { Row, Col, Form, FormItem, Input, Button, Select, Option, Radio, RadioGroup, DatePicker, MessageBox, Message } from 'element-ui';

    Vue.component(Row.name, Row);
    Vue.component(Col.name, Col);
    Vue.component(Form.name, Form);
    Vue.component(FormItem.name, FormItem);
    Vue.component(Input.name, Input);
    Vue.component(Button.name, Button);
    Vue.component(Select.name, Select);
    Vue.component(Option.name, Option);
    Vue.component(Radio.name, Radio);
    Vue.component(RadioGroup.name, RadioGroup);
    Vue.component(DatePicker.name, DatePicker);
    // Vue.use(Loading.directive);
    // Vue.component(DatePicker.name, DatePicker);

    // Vue.prototype.$loading = Loading.service;
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$message = Message;
    
    // import Vconsole from 'vconsole'
    // const vConsole =new Vconsole()
    // Vue.use(vConsole)

    export default {
        data() {
            var validatePhone = async (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'))
                }
                if (!/^[1][2-9][0-9]{9}$/.test(value)) {
                    return callback(new Error('手机号格式有误'))
                }
                const IsPhone = await this.getDoctorNurseInformationByPhone(value)
                if (IsPhone.success && IsPhone.data._id !== this.form._id) {
                    return callback(new Error('已经存在该号码'))
                }
                callback()
            }
            var sparePhone = async (rule, value, callback) => {
                if (value) {
                    if (!/^[1][2-9][0-9]{9}$/.test(value)) {
                        return callback(new Error('手机号格式有误'))
                    }
                    const IsPhone = await this.getDoctorNurseInformationByPhone(value)
                    if (IsPhone.success && IsPhone.data._id !== this.form._id) {
                        return callback(new Error('已经存在该号码'))
                    }
                }
                callback()
            }
            return {
                form: {
                    Phone: '',
                    ConfirmTime: ''
                },
                XLBirthday: '', // 新历出生日期
                hospitalOptions: [],
                SexOptions: ['男', '女'],
                JobOptions: [],
                departmentList: [],
                MonthlyCalendarOptions: [],
                loading: false,
                btnLoading: false,
                // 校验规则
                rules: {
                    HospitalName: [
                        { required: true, message: '请输入医院', trigger: 'blur' },
                        { max: 50, message: '最大长度不能超过50位', trigger: 'blur' }
                    ],
                    Department: [
                        { required: true, message: '请选择科室', trigger: 'change' }
                    ],
                    JobTitle: [
                        { required: true, message: '请选择职称', trigger: 'change' }
                    ],
                    Name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { max: 32, message: '最大长度不能超过32位', trigger: 'blur' }
                    ],
                    Phone: [
                        { required: true, validator: validatePhone, trigger: 'blur' }
                    ],
                    Phone1: [
                        { required: false, validator: sparePhone, trigger: 'blur' }
                    ],
                    Phone2: [
                        { required: false, validator: sparePhone, trigger: 'blur' }
                    ],
                    IDCardNumber: [
                        { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号格式有误', trigger: 'blur' }
                    ],
                    ConfirmTime: [
                        { required: true, message: '请填写确认时间', trigger: 'blur' }
                    ]
                },
                VIPoptions: ['V1', 'V2', 'V3', 'V4', 'V5', 'V6', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'Q1'],
                Phone: ''
            }
        },
        async created() {
            this.JobOptions = await this.getDictionary('职务')
            this.departmentList = await this.getDictionary('科室')
            this.MonthlyCalendarOptions = await this.getDictionary('月历')
        },
        mounted() {
            this.init()
        },
        methods: {
            async init() {
                this.btnLoading = true
                const result = await this.$request({
                    method: 'GET',
                    url: this.$api.getWXSign,
                    params: {
                        Url: window.location.href
                    }
                })
                if (result.success) {

                    let data = result.data
                    let timestamp = data.timestamp
                    let nonceStr = data.noncestr
                    let signature = data.signature
                    const corpSignature = data.corpSignature || signature
                    const agentSignature = data.agentSignature || signature

                    ww.register({
                        agentId: this.$agentid,       // 必填，当前用户企业所属应用的AgentId
                        corpId: 'wxdf5df2adda0272b2',       // 必填，当前用户企业所属企业ID
                        jsApiList: ['getContext', 'getCurExternalContact'],  // 必填，需要使用的JSAPI列表
                        async getConfigSignature() {
                            return { timestamp, nonceStr, signature: corpSignature }
                        },
                        async getAgentConfigSignature() {
                            return { timestamp, nonceStr, signature: agentSignature }
                        },
                    })
                }

                ww.getContext({
                    complete: function (res) {
                        console.log('getContext', res)
                    }
                })

                let that = this
                ww.getCurExternalContact({
                    complete: function (res) {
                        console.log('getCurExternalContact1', res)
                        that.getCustomerDetail(res.userId)
                    }
                })
            },
            save() {
                this.btnLoading = true
                this.$refs.form.validate(async valid => {
                    if (valid) {
                        this.$confirm('是否保存信息', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async () => {
                            if (this.form.BranchlId === '') {
                                delete this.form.BranchlId
                            }
                            // delete this.form._id
                            // delete this.form.Profile
                            // this.form.Operation = this.$route.query.displayName

                            let result = await this.postDNInfo(this.form._id, this.form)
                            if (result.data.success) {
                                this.$message({
                                    type: 'success',
                                    message: '保存成功!'
                                })
                            }
                            this.btnLoading = false
                        }).catch((e) => {
                            this.btnLoading = false
                            this.$message({
                                type: 'info',
                                message: '已取消保存'
                            })
                        })
                    } else {
                        this.btnLoading = false
                    }
                })
            },
            async getCustomerDetail(userid) {
                const res = await this.$request({
                    url: this.$api.getCustomerDetail,
                    method: 'GET',
                    params: { userid: userid }
                })
                if (res.success) {
                    if (res.data && res.data.follow_user && res.data.follow_user[0] && res.data.follow_user[0].remark_mobiles && res.data.follow_user[0].remark_mobiles[0]) {
                        this.Phone = res.data.follow_user[0].remark_mobiles[0]
                        await this.getUserInfo({Phone: this.Phone})
                    } else {
                        console.error('没有获取到手机号码')
                    }
                }
                this.btnLoading = false
            },
            async getUserInfo(query) {
                const res = await this.$request({
                    url: this.$api.getUserInfoFromQuanByOpenId,
                    method: 'GET',
                    params: query
                })
                if (res.success) {
                    this.form = res.data
                    // 有出生日期时调用转换新历、农历日期方法
                    if (this.form.Birthday) {
                        this.formatterDate()
                    }
                }
            },
            changeTime(name) {
                this.$set(this.form, name, this.$moment().format('YYYY-MM-DD'))
            },
            // 医院选择器远程搜索
            hosRemoteMethod(query) {
                if (query !== '') {
                    this.loading = true
                    setTimeout(async () => {
                        this.loading = false
                        await this.getHospitalByName(query)
                    }, 200)
                } else {
                    this.hospitalOptions = []
                }
            },
            handleHosChange(val) { // 选择医院名称
                var form = this.hospitalOptions.find(e => e.label === val) // 按选中医院的名字找到编码
                // code和地址都同步
                this.form.Code = form.code
                this.form.HospitalAddress = form.address
            },
            handleClear() { // 清空医院选择
                this.form.Code = ''
                this.form.HospitalAddress = ''
                // this.branchList = [] // 清空分院
            },
            handleDateChange(val) { // 选择生日
                if (this.form.Birthday) {
                    // this.Age = jsGetAge(this.form.Birthday)
                    this.formatterDate()
                }
            },
            handleCalendarTypeChange() {
                // 月历类型变化时，如果有出生日期，重新计算新历生日
                if (this.form.Birthday) {
                    this.formatterDate()
                }
            },
            // 新历、农历转换（新历生日：今年该生日对应的公历日期，依赖 calendar.js 的 betweenLunarDays 正确）
            formatterDate() {
                if (!this.form.Birthday) {
                    this.XLBirthday = ''
                    this.$forceUpdate()
                    return
                }
                if (this.form.MonthlyCalendar === '新历') {
                    this.XLBirthday = new Date().getFullYear() + this.form.Birthday.slice(4)
                } else if (this.form.MonthlyCalendar === '农历') {
                    const date = this.form.Birthday.split('-').map(Number)
                    const lunarMonth = date[1]
                    const lunarDay = date[2]
                    const currentSolarYear = new Date().getFullYear()
                    let newDate = calendar.toSolar(currentSolarYear, lunarMonth, lunarDay)
                    if (Number(newDate[0]) !== currentSolarYear) {
                        newDate = calendar.toSolar(currentSolarYear - 1, lunarMonth, lunarDay)
                    }
                    this.XLBirthday = newDate.join('-')
                }
                this.$forceUpdate()
            },
            // 根据名字获取字典明细项
            async getDictionary (Name) {
                const res = await axios.get('https://wap.jafron.com:8051/api/DictionaryItem/getDictionaryDetailName', {
                    params: { Name }
                })
                if (res.data.success) {
                    return res.data.data
                }
            },
            async getHospitalByName(Name) {
                const res = await axios.get('https://wap.jafron.com:8051/api/Hospital/getHospitalByName', {
                    params: { Name }
                })
                if (res.data.success) {
                    this.hospitalOptions = res.data.data.map(e => { return { label: e.Name, id: e._id, code: e.Code, address: e.Address } })
                }
            },
            // 查询手机号码数组查询医护信息
            async getDoctorNurseInformationByPhone(Phone) {
                let url = 'https://wap.jafron.com:8051/api/DoctorNurseInformationController/getDoctorNurseInformationByPhone'
                const res = await axios.get(url, {
                    params: { Phone }
                })
                return res.data
            },
            postDNInfo (id, obj) {
                const data = JSON.parse(JSON.stringify(obj))
                delete data._id
                delete data.Profile
                let url = 'https://wap.jafron.com:8051/api/DoctorNurseInformationController/postDoctorNurseInformationById?Id=' + id
                return axios.post(url, data)
            },
            async SynchronousData (id) {
                this.btnLoading = true
                const result = await this.$request({
                    url: this.$api.SynchronousData,
                    method: 'POST',
                    params: {Profile: id}
                })
                if (result.success) {
                    this.$message({
                        type: 'success',
                        message: '同步成功!'
                    })
                    this.btnLoading = false
                }
            }
            // putDNInfo (openid, data) {
            //     // let url = 'https://wap.jafron.com:8051/api/DoctorNurseInformationController/postDoctorNurseInformation?Phone=' + phone
            //     let url ='https://wap.jafron.com:8051/api/DoctorNurseInformationController/putDNInfo?openid=' + openid
            //     let obj = {
            //         'Content-Type': 'application/x-www-form-urlencoded',
            //         'type': 'nurse',
            //         'uid': this.form._id
            //     }
            //     return axios.put(url, data, {headers: obj})
            // }
        }
    }
</script>

<style>
#app {
    background-color: white;
    height: auto;
}
</style>
<style scoped lang="less">
.main {
    margin: 0 12px;
}

.foot {
    margin: 20px 0;
    text-align: center;
}
</style>
<!-- 引入样式 -->
<!-- <link rel="stylesheet" href="https://unpkg.com/element-ui/lib/theme-chalk/index.css"> -->